module.exports = __webpack_public_path__ + "static/media/Rysunek15.7247d8f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/szatnia/Rysunek15.jpg
// module id = 263
// module chunks = 0